<template>
  <aside
    class="sidebar"
    :class="{
      show: moduleStore.open
    }"
  >
    <LayoutSidebarMenu />
    <Transition :name="effect" mode="out-in">
      <LayoutSidebarNavigation v-if="!!module && module.navigation" v-bind="module" :key="prefix" />
    </Transition>
  </aside>
</template>

<script setup>
  const route = useRoute()
  const moduleStore = useModuleStore()

  const effect = ref("navigation")

  const prefix = computed(() => route?.path?.split("/")[1])
  const module = computed(() => moduleStore.modules?.[prefix.value] ?? false)

  watch(
    () => route.path,
    (newValue, oldValue) => {
      const oldModule = moduleStore.modules[oldValue?.split("/")[1]]
      const newModule = moduleStore.modules[newValue?.split("/")[1]]

      effect.value = oldModule && newModule && oldModule.navigation && newModule.navigation ? "fade" : "navigation"
    }
  )
  watch(
    () => route.name,
    (newValue, oldValue) => {
      if (newValue !== "error") moduleStore.open = false
    }
  )
</script>

<style lang="scss">
  .sidebar {
    --sidebar-menu-width: 56px;
    --sidebar-navigation-width: 240px;

    @apply sticky top-0 flex bg-white flex-none z-20 overflow-hidden h-screen;
    box-shadow: inset -1px 0px 0px 0 theme("colors.gray.50");

    @media (max-width: 640px) {
      width: 100%;
      visibility: hidden;
      opacity: 0;
      pointer-events: none;
      transition: all 0.2s ease-in-out;
      position: fixed;

      &.show {
        visibility: visible;
        opacity: 1;
        pointer-events: auto;
      }
    }
  }
</style>
